import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {DiscountService} from "../service/discount.service";
import {Discount} from "../model/discount";

@Injectable()
export class DiscountResolve implements Resolve<Discount> {
    constructor(private discountService: DiscountService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Discount> {
        return this.discountService.getById(route.params.id);
    }
}
